<div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
  <button type="button" class="close" aria-label="Close"
    (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <ng-template DynamicModal></ng-template>
</div>

<ngx-loading [show]="loader.value$ | async"
  [config]="{animationType: 'rectangle-bounce', backdropBorderRadius: '3px'}"></ngx-loading>
<!-- <app-modal-body [props]="props"></app-modal-body>
  
  <ngx-loading [show]="loading"></ngx-loading> -->